import { getWeekBoundaries, offsetDate } from '@helper/utils/date'

import type { DatePreset } from './date-preset-picker'

export const START_PRESETS: DatePreset[] = [
  { label: 'Sekarang', resolve: () => new Date(), exact: true },
  { label: 'Besok', resolve: () => offsetDate(new Date(), { days: 1 }) },
  { label: 'Minggu ini', resolve: () => getWeekBoundaries(0).endOfWeek },
  { label: 'Minggu depan', resolve: () => getWeekBoundaries(1).endOfWeek },
]

export const DUE_PRESETS: DatePreset[] = [
  { label: 'Kapan saja', resolve: () => null },
  { label: 'Hari ini', resolve: () => new Date() },
  { label: 'Besok', resolve: () => offsetDate(new Date(), { days: 1 }) },
  { label: 'Minggu ini', resolve: () => getWeekBoundaries(0).endOfWeek },
  { label: 'Minggu depan', resolve: () => getWeekBoundaries(1).endOfWeek },
]
